<template>
  <div id="app">
    <tab></tab>
    <router-view />
    <footermode></footermode>
  </div>
</template>

<script>
import tab from "./components/header";
import footermode from "./components/footer";
export default {
  name: "App",
  components: {
    tab,
    footermode
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue